import axios from 'axios';
import {
  backendRequestBaseParams as baseParams,
  backendUrl,
} from '../constants/general';

export const fetchBookingCount = (params) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/dashboard/getBookingLocationCount`,
    params,
  });

export const fetchBookingEmployeeTypeCount = (params) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/dashboard/getBookingEmployeeTypesCount`,
    params,
  });

export const fetchBookingBookingStatusCount = (params) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/dashboard/getBookingStatusCount`,
    params,
  });

export const fetchActualVsPlannedAllCounts = (params) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/dashboard/getActualVsPlannedAllCounts`,
    params,
  });

export const fetchActualVsPlannedCountPerLocation = (params) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/dashboard/getActualVsPlannedCountPerLocation`,
    params,
  });

export const fetchActualVsPlannedRange = (params) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/dashboard/getActualVsPlannedRange`,
    params,
  });

export const fetchPlannedCostByLocationType = (params) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/dashboard/getPlannedCost`,
    params,
  });

export const fetchAllPlannedCost = (params) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/dashboard/getAllPlannedCost`,
    params,
  });
